import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServicioUtilService } from '../../../../services/servicio-util.service';
import { EntidadEmpresarialEntity } from '../../../../services/servicio-entidad.service';
import { ParametrosProcedimientosAdmisionEntity, BodyProcedimientosAdmisionEntity,
  HeadProcedimientosAdmisionEntity } from '../../../../services/servicio-procedimientos-admision.service';

@Component({
  selector: 'app-reporte-procedimientos-admisiones',
  templateUrl: './reporte-procedimientos-admisiones.component.html',
  styleUrls: ['./reporte-procedimientos-admisiones.component.css']
})
export class ReporteProcedimientosAdmisionesComponent implements OnInit {

  loading: boolean;
  preloading = true;
  mensajeError: string;

  fechaImpresion: Date;

  entidad: EntidadEmpresarialEntity;
  head: HeadProcedimientosAdmisionEntity;
  data: BodyProcedimientosAdmisionEntity[] = [];

  public parametrosReporte: ParametrosProcedimientosAdmisionEntity = { };

  constructor(private activatedRoute: ActivatedRoute,
    private servicioUtil: ServicioUtilService) {
      this.activatedRoute.params.subscribe(params => {
        this.parametrosReporte.codigoBaseDatos = params['codigoBaseDatos'];
        this.parametrosReporte.uncoSede = params['uncoSede'];
        this.parametrosReporte.uncoLogin = params['uncoLogin'];
        this.parametrosReporte.uncoAdmision = params['uncoAdmision'];
      });
  }

  ngOnInit() {
  }

  // Listener

  updateLoading(value: boolean) {
    this.loading = value;
    this.mensajeError = null;
  }

  updateError(error: string) {
    this.mensajeError = error;
    this.loading = false;
  }

  updateData(report: {entidad: EntidadEmpresarialEntity, head: HeadProcedimientosAdmisionEntity, data: BodyProcedimientosAdmisionEntity[] }) {
    this.preloading = false;
    this.mensajeError = null;
    this.loading = false;
    this.fechaImpresion = new Date();
    this.entidad = report.entidad;
    this.head = report.head;
    this.data = report.data;
  }

  // Auxiliar

  isPrepare() {
    return !this.loading && !this.mensajeError;
  }

  isPrepareData() {
    return this.isPrepare() && this.head && this.data && this.data.length > 0;
  }
}
